module.exports = __webpack_public_path__ + "img/miini.01fc63cc.svg";